import { Bank } from '@/api/dictionary';

export const NAMESPACE = 'DICTIONARY';

export type { Bank };

export interface State {
  initialized: boolean;
  banks: Bank[];
}

export const initialState: State = {
  initialized: false,
  banks: [],
};
